import { render, staticRenderFns } from "./FlightOnlyItem.vue?vue&type=template&id=d37b6646&scoped=true"
import script from "./FlightOnlyItem.vue?vue&type=script&lang=js"
export * from "./FlightOnlyItem.vue?vue&type=script&lang=js"
import style0 from "./FlightOnlyItem.vue?vue&type=style&index=0&id=d37b6646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37b6646",
  null
  
)

export default component.exports